import React from 'react'

import ErrorContainer from '../components/alerts/ErrorContainer'

const Error404Screen = props => <ErrorContainer />

export default Error404Screen
